import qs from 'qs'

export const queryPublicationsPageThumbnail = () => {
  const query = qs.stringify(
    {
      populate: {
        ...queryFragmentSingleTypeDefault
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `publications-page?${query}`
}
